<template>
  <TableGradient
      icon-name="hospital"
      :title="$t('core_care_units.index.listagem_unidades')"
      :text-empty="$t('core_care_units.index.unidade_nao_encontrada')"
      route-new="corecareunits.create"
      :text-new="$t('core_care_units.index.criar_unidade')"
      :fields="fields"
      :items="careunits"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('corecareunits/listAllPaginated', evt)"
      table-data
      disable-filters
  >
    <template v-slot:cell(id)="{ index, item: { id }}">
      <router-link :id="`link-edit-${index}`" :to="{ name: 'corecareunits.edit', params: { id }}" class="font-weight-bold">
        {{ $t('core_care_units.index.editar') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      careunits: 'corecareunits/all',
      paginator: 'corecareunits/pagination',
      store_isLoading: 'corecareunits/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('core_care_units.index.nome'), sortable: true},
        {key: 'mnemonic', label: this.$t('core_care_units.index.apelido'), sortable: true},
        {key: 'veus_care_unit_id', label: 'VS ID', sortable: true},
        {key: 'id', label: this.$t('core_care_units.index.editar')}
      ]
    }
  },
  methods: {
    ...mapActions([
      'corecareunits/listAllPaginated'
    ])
  },
  mounted() {
    this['corecareunits/listAllPaginated'](this.paginator)
    this.mounted = true
  }
}
</script>